import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { CATEGORY_ATTRIBUTES, CATEGORY_SEPARATOR } from './category-nav';
import { slugPathToURL } from './category-routes';

// `zuper-categories` carries the deepest populated level as e.g.
// `lvl2: "trofima > galaktokomika-eidi-psygeiou > gala-kai-fytika-rofimata"`
// (URL slugs; nothing in the deeper lvl3-lvl5 keys), plus a parallel
// `titles` array of the DISPLAY titles for that same path (e.g.
// `["Τρόφιμα", "Γαλακτοκομικά & Είδη Ψυγείου", "Γάλα και Φυτικά
// Ροφήματα"]`). Records carry everything this needs locally now -- no
// taxonomy fetch on detail pages, and no broken links: slug paths taken
// straight from a record always resolve (they came from the same
// taxonomy), so there's no bracket-URL fallback to fall back to.
function categorySlugSegments(categories): string[] {
  if (!categories) return [];

  for (let i = CATEGORY_ATTRIBUTES.length - 1; i >= 0; i--) {
    const path = categories[`lvl${i}`];
    if (path) {
      return path.split(CATEGORY_SEPARATOR).map((segment) => segment.trim());
    }
  }

  return [];
}

// Shared prominent, linked category breadcrumb for cluster and product
// pages. Renders nothing when the record has no `zuper-categories` (e.g.
// most products, which are only categorized once curated).
export function CategoryBreadcrumb({ categories }) {
  const slugs = categorySlugSegments(categories);

  if (slugs.length === 0) return null;

  const titles = categories.titles || [];

  return (
    <nav
      aria-label="Κατηγορία"
      className="flex flex-wrap items-center gap-x-1.5 gap-y-1 pb-2 text-sm sm:text-base"
    >
      {slugs.map((slug, index) => (
        <Fragment key={index}>
          {index > 0 && <span className="text-gray-400">›</span>}
          <Link
            to={slugPathToURL(slugs.slice(0, index + 1))}
            className="font-medium text-zuper-700 hover:text-zuper-900 hover:underline"
          >
            {titles[index] ?? slug}
          </Link>
        </Fragment>
      ))}
    </nav>
  );
}
